exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".feature-dark {\r\n    background-color: #262F36;\r\n    color: white;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/components/static-page/static-page.component.css
// module id = 442
// module chunks = 0